require('jquery-touchswipe');

function Cycle(options) {
	this.options = options;
}

Cycle.prototype.gotoSlide = function gotoSlide(newIndex, forward) {
	if (forward === undefined) {
		forward = newIndex >= this.options.currentIndex;
	}

	var options = this.options;

	if (newIndex === options.currentIndex) {
		return;
	}

	var $current = options.slides.eq(options.currentIndex);
	var $next = options.slides.eq(newIndex);

	options.container.trigger('cycle-before', [options, $current, $next, forward]);

	if (forward && $next.hasClass(options.slideLeftClass)) {
		$next.addClass('no-transition').removeClass(options.slideLeftClass);
		$next.height(); // trigger reflow
		$next.removeClass('no-transition');
	}
	if (!forward && !$next.hasClass(options.slideLeftClass)) {
		$next.addClass('no-transition').addClass(options.slideLeftClass);
		$next.height(); // trigger reflow
		$next.removeClass('no-transition');
	}
	if (forward) {
		$current.addClass(options.slideLeftClass);
	}
	$current.removeClass(options.slideActiveClass);
	$next.addClass(options.slideActiveClass).removeClass(options.slideLeftClass);


	options.pager.find('.' + options.pagerActiveClass).removeClass(options.pagerActiveClass);
	options.pager.find('.' + options.pagerClass).eq(newIndex).addClass(options.pagerActiveClass);

	options.currentIndex = newIndex;
	options.currentSlide = $next;

	options.container.trigger('cycle-after', [options, $current, $next, forward]);
};

Cycle.prototype.prev = function prev() {
	var index = this.options.currentIndex - 1;
	if (index < 0) {
		index = this.options.slides.length - 1;
	}
	return this.gotoSlide(index, false);
};

Cycle.prototype.next = function next() {
	var index = this.options.currentIndex + 1;
	if (index >= this.options.slides.length) {
		index = 0;
	}
	return this.gotoSlide(index, true);
};

$.fn.cycle = function(options) {
	var log = $.fn.cycle.log;

	if (!this.length && !$.isReady) {
		log('requeuing slideshow (dom not ready)');

		var o = {
			s: this.selector,
			c: this.context
		};

		$(function() {
			$(o.s, o.c).cycle(options);
		});

		return this;
	}

	return this.each(function() {
		var $container = $(this);

		if ($container.data('cycle')) {
			return; // already initialized
		}

		var opts = $.extend({}, $.fn.cycle.defaults, options || {});
		opts.container = $container;
		opts.slides = opts.slides.jquery ? opts.slides : $container.find(opts.slides);
		opts.next = opts.next.jquery ? opts.next : $container.find(opts.next);
		opts.prev = opts.prev.jquery ? opts.prev : $container.find(opts.prev);
		opts.pager = opts.pager.jquery ? opts.pager : $container.find(opts.pager);
		opts.currentSlide = opts.slides.filter('.' + opts.slideActiveClass);
		opts.currentIndex = opts.slides.index(opts.currentSlide);
		$container.data('cycle', opts);

		var API = new Cycle(opts);
		opts.API = API;

		opts.prev.on('click', function(event) {
			event.preventDefault();
			event.stopPropagation();

			API.prev();
		});

		opts.next.on('click', function(event) {
			event.preventDefault();
			event.stopPropagation();

			API.next();
		});

		opts.pager.on('click', '.' + opts.pagerClass, function(event) {
			event.preventDefault();
			event.stopPropagation();

			API.gotoSlide(opts.pager.find('.' + opts.pagerClass).index(this));
		});

		if (opts.swipe) {
			$container.swipe({
				fallbackToMouseEvents: false,
				swipeLeft: function() {
					API.next();
				},
				swipeRight: function() {
					API.prev();
				},
				preventDefaultEvents: false,
				allowPageScroll: 'vertical'
			});
		}
	});
};

// default logger
$.fn.cycle.log = function log() {
	if (window.console && window.console.log) {
		window.console.log('[cycle vierwd] ' + Array.prototype.join.call(arguments, ' '));
	}
};

$.fn.cycle.defaults = {
	slides: '.slide',
	slideClass: 'slide',
	slideLeftClass: 'slide--left',
	slideActiveClass: 'slide--active',
	next: '> .slide__next',
	prev: '> .slide__prev',
	pager: '> .slide__navigation',
	pagerClass: 'slide__link',
	pagerActiveClass: 'slide__link--active'
};
